/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadWarningDetails } from './LeadWarningDetails';
import {
    LeadWarningDetailsFromJSON,
    LeadWarningDetailsFromJSONTyped,
    LeadWarningDetailsToJSON,
} from './LeadWarningDetails';

/**
 * 
 * @export
 * @interface LeadWarning
 */
export interface LeadWarning {
    /**
     * 
     * @type {string}
     * @memberof LeadWarning
     */
    type: LeadWarningTypeEnum;
    /**
     * 
     * @type {LeadWarningDetails}
     * @memberof LeadWarning
     */
    details?: LeadWarningDetails;
}


/**
 * @export
 */
export const LeadWarningTypeEnum = {
    PackageLimitExceeded: 'PACKAGE_LIMIT_EXCEEDED'
} as const;
export type LeadWarningTypeEnum = typeof LeadWarningTypeEnum[keyof typeof LeadWarningTypeEnum];


/**
 * Check if a given object implements the LeadWarning interface.
 */
export function instanceOfLeadWarning(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function LeadWarningFromJSON(json: any): LeadWarning {
    return LeadWarningFromJSONTyped(json, false);
}

export function LeadWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'details': !exists(json, 'details') ? undefined : LeadWarningDetailsFromJSON(json['details']),
    };
}

export function LeadWarningToJSON(value?: LeadWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'details': LeadWarningDetailsToJSON(value.details),
    };
}

